export default __webpack_public_path__ + "static/media/discord-block-text.789a81eb.png";